// Story 22.3 (FR88) — the eligibility read the reversal dialog opens on.
//
// The dialog asks the SERVER whether this attachment is still reversible and
// what the reversal would cost the organization's seat pool. It does not derive
// either. That is AC25's rule and it has a specific failure in mind: a browser
// that compares `assigned_at` against a window length of its own drifts the
// moment somebody changes `SEAT_ATTACHMENT_CORRECTION_WINDOW_DAYS`, and drifts
// in the direction that offers a Confirm the server will refuse.
//
// `retry: false` matches `useAdminUserDetail`: a 403 or a 404 here is an answer,
// not a blip, and re-asking three times only delays the dialog telling the
// administrator what it found.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { ReversalPreflightData } from "@/hooks/queries/admin-users-types";

export const REVERSAL_PREFLIGHT_QUERY_KEY = "reversal-preflight";

export function reversalPreflightQueryKey(orgId: string, userId: string) {
  return [REVERSAL_PREFLIGHT_QUERY_KEY, orgId, userId] as const;
}

/** `GET /admin/orgs/{org_id}/clinicians/{user_id}/reversal-preflight`. */
export function reversalPreflightPath(orgId: string, userId: string): string {
  return `/admin/orgs/${encodeURIComponent(orgId)}/clinicians/${encodeURIComponent(
    userId,
  )}/reversal-preflight`;
}

/**
 * `enabled` is the caller's, so the screen can mount this only while the dialog
 * is open — the read discloses an organization's seat position and an account's
 * roster provenance, and there is no reason to fetch it for every visitor to
 * the user-detail screen.
 */
export function useReversalPreflight(
  orgId: string | null | undefined,
  userId: string,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: reversalPreflightQueryKey(orgId ?? "", userId),
    queryFn: () => apiFetch<ReversalPreflightData>(reversalPreflightPath(orgId!, userId)),
    enabled: Boolean(orgId) && (options.enabled ?? true),
    retry: false,
  });
}
